import template from "./orders.html";
import controller from "./orders.controller";
import "./orders.scss";

let branchManagementOrdersComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchManagementOrdersComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/orders/orders.component.js